import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=dfe0a736&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=dfe0a736&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "dfe0a736",
  null
  
)

export default component.exports